module.exports = __webpack_public_path__ + "img/12.960814ef.jpg";